import { useMedigapQuoteQuery } from '@coverright/data-access/types/medigap';
import { useUserProfile } from '../enrollment/use-user-profile';

export const useMedigapQuote = () => {
  const profile = useUserProfile();
  const { data } = useMedigapQuoteQuery({
    variables: { id: profile?.medigapQuoteId },
    skip: !profile?.medigapQuoteId,
  });
  return data?.medigapQuote;
};
